export const JOBBER_SETTINGS_PATH = '/settings?tab=jobber&reason=auth-required';

let navigationStarted = false;

export function isJobberAuthRequired(payload = {}) {
  const message = `${payload.error || ''} ${payload.message || ''}`.toLowerCase();
  return (
    payload.code === 'JOBBER_AUTH_REQUIRED' ||
    (message.includes('jobber') && (
      message.includes('connect') ||
      message.includes('reconnect') ||
      message.includes('token is expired') ||
      message.includes('authorization failed')
    ))
  );
}

export function goToJobberSettings() {
  if (navigationStarted) return;

  const query = new URLSearchParams(window.location.search);
  if (window.location.pathname === '/settings' && query.get('tab') === 'jobber') return;

  navigationStarted = true;
  window.location.assign(JOBBER_SETTINGS_PATH);
}
